import { Component } from '@angular/core';
import { BaseMortgageApplicationComponent } from '../../../pages/base-mortgage-application.component';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-your-property-additional-info',
  templateUrl: './your-property-additional-info.component.html',
  styleUrls: ['./your-property-additional-info.component.scss']
})
export class YourPropertyAdditionalInfoComponent extends BaseMortgageApplicationComponent {
  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }
}
